<script setup lang="ts">
import { computed, inject, Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSteps } from '/@src/composable/useSteps'
import { NazvyKrokov } from '/@src/utils/zoppm/types'
import { VyzvaSpecificationPublicResponse } from '/@src/client-public'
import { ZoPPMDynoSekcia } from '/@src/client-portal'
import { ZoppmSchemeTransformer } from '/@src/utils/zoppm'
import { NazvyAssemblySekcii } from '/@src/utils/zoppm/ZoppmSchemeTransformer/types'

export interface DalsieUdajeZiadosti {
  udaje: ZoPPMDynoSekcia
  isValidSection: boolean
}

const props = withDefaults(defineProps<DalsieUdajeZiadosti>(), {
  udaje: undefined,
  isValidSection: false,
})

const { t } = useI18n()
const steps = useSteps()
const specResponse = inject<VyzvaSpecificationPublicResponse>('specResponse')
const stavPodana = inject<boolean>('stavPodana', false)

const udajeData = computed(() => props.udaje)

const schemeTransformer = inject<Ref<ZoppmSchemeTransformer>>('schemeTransformer')
const sekciaRefNazov: NazvyAssemblySekcii = 'zoppm.ds.ziadost'
const heading = computed(
  () =>
    schemeTransformer?.value.getSectionTitle(sekciaRefNazov) ||
    t('zoppm.zhrnutie.dalsieUdajeZiadosti.mainHeading')
)

const dynoSekcia = computed(() =>
  specResponse?.zoppmSpec?.sekcie?.find(
    (sekcia) => sekcia?.sekciaRef?.nazov === sekciaRefNazov
  )
)
</script>

<template>
  <IDSKHeading as="h2" variant="l">
    {{ heading }}
  </IDSKHeading>

  <div v-if="props.isValidSection">
    <zhrnutie-error />
  </div>

  <DynoSekcia
    :hodnoty-dyno-prvkov="udajeData?.hodnotyDynoPrvkov"
    :dyno-sekcia="dynoSekcia"
  />

  <div v-if="!stavPodana" class="d-flex align-items-right">
    <IDSKButton
      variant="secondary"
      type="button"
      class="mb-0"
      :data-test-id="`zoppm-dalsie-udaje-ziadosti-edit`"
      @click="
        () =>
          steps.setStep(NazvyKrokov['dalsieUdajeZiadosti'], {
            ref: NazvyKrokov['zhrnutie'],
          })
      "
    >
      {{ t('zoppm.zhrnutie.editBtn') }}
    </IDSKButton>
  </div>

  <hr class="mb-8 mt-8" />
</template>
